import { capitalCase } from 'change-case';

import { DataSourceConnectionParams } from './dataSourceSections';

const DATA_SOURCE_LABELS: Record<string, string> = {
    airtable: 'Airtable',
    asana: 'Asana',
    attio: 'Attio',
    box: 'Box',
    clickup: 'ClickUp',
    close: 'Close',
    coda: 'Coda',
    confluence: 'Confluence',
    docusign: 'DocuSign',
    dropbox: 'Dropbox',
    'google-drive': 'Google Drive',
    'google-sheets': 'Google Sheets',
    hubspot: 'HubSpot',
    miro: 'Miro',
    monday: 'Monday.com',
    notion: 'Notion',
    pipedrive: 'Pipedrive',
    salesforce: 'Salesforce',
    slack: 'Slack',
    smartsheet: 'Smartsheet',
    wealthbox: 'Wealthbox',
    wrike: 'Wrike',
};

const NYLAS_PROVIDER_LABELS: Record<string, string> = {
    google: 'Gmail',
    microsoft: 'Microsoft Outlook',
};

export const dataSourceLabelFor = (option: string, params?: DataSourceConnectionParams) => {
    if (option === 'nylas') {
        return NYLAS_PROVIDER_LABELS[params?.provider ?? ''] ?? 'Email & Calendar';
    }

    return DATA_SOURCE_LABELS[option] ?? capitalCase(option);
};
